import React, { useContext, useEffect } from 'react';
import { withRouter } from "react-router-dom";
import { AppActions } from 'store';
import { DispatchContext } from 'context';
import './main.css';
import 'pure-react-carousel/dist/react-carousel.es.css';
import { Header } from 'app/header';
import { Paquetes } from 'app/paquetes';
// import { BuscadorExterno } from 'app/buscador-externo';
import { Contacto } from 'app/contacto';
import { Footer } from 'app/footer';
// import { SelectorTema } from 'app/selector-thema';
import { Element as SMElement, scroller } from 'react-scroll';
import { Servicios } from 'app/servicios';
import { Nosotros } from 'app/nosotros';
import { Inicio } from 'app/inicio';
import { MessengerChat } from 'react-messenger-chat-plugin';
import { WhatsAppFloat } from 'components/whatsapp';

const Main = props => {
    const dispatch = useContext(DispatchContext);
    // const [imagenesListas, setImagenesListas] = useState(false);
    useEffect(() => {
        dispatch(AppActions.setLoading(false));
        dispatch(AppActions.setActionsDisabled(false));
        document.title = 'Servitravel.com.py';

    }, [dispatch]);
    const scrollear = (target) => {
        let offs = (target === 'inicio') ? 0 : -100;
        scroller.scrollTo(target, {
            duration: 1000,
            delay: 100,
            smooth: true,
            offset: offs, // Scrolls to element + 50 pixels down the page
        })
    }

    return (
        <div className="bs-bbox">
            <MessengerChat pageId='102483696457238' language='es_ES' />
            {/* <SelectorTema/> */}
            {/*{scrollY && scrollY > 300 ? <button className="w3-btn grow"
                onClick={() => scrollear('inicio')}
                style={{ backgroundColor: Themes[indexTema].TH, position: 'fixed', bottom: 100, right: 30, zIndex: 200, borderRadius: '40px', padding: '15px' }}><FontAwesomeIcon className="fa-rotate-270" size="1x" icon={faPlane} color="#fff"></FontAwesomeIcon></button> : null} */}

            <SMElement name="inicio">
                <Header scrollear={scrollear} />
                <Inicio />
            </SMElement>
            <SMElement name="paquetes">
                <Paquetes></Paquetes>
            </SMElement>
            <SMElement name="servicios">
                <Servicios></Servicios>
            </SMElement>
            {/*  <SMElement name="galeria">
                <Galeria></Galeria>
            </SMElement> */}
            <SMElement name="nosotros">
                <Nosotros></Nosotros>
            </SMElement>
            <SMElement name="contacto">
                <Contacto></Contacto>
            </SMElement>
            <WhatsAppFloat />
            <Footer />
            
        </div>
    );
}
export default withRouter(Main);